// Sinestesia — Autoplay video
document.addEventListener('DOMContentLoaded', function () {
  function initVideos() {
    var videos = document.querySelectorAll('video');
    videos.forEach(function (video) {
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      video.play().catch(function () {
        document.addEventListener('touchstart', function () {
          video.play();
        }, { once: true });
      });
    });
  }
  initVideos();
  setTimeout(initVideos, 1000);
});

// Sinestesia — Segunda foto al tocar en celular (tarjetas de producto)
// Igual que trinitylabel.com: en PC la segunda foto aparece con el mouse
// (hover de Dawn). En pantallas táctiles no hay mouse, así que la foto cambia
// apenas el dedo toca la tarjeta (también mientras scrolleás) y queda así
// hasta que tocás otra cosa. Un toque normal sigue abriendo el producto.
// Estilos en assets/sinestesia-cards.css (bloque "segunda foto al tocar").
// Usa delegación en document: sirve para tarjetas que carga la navegación AJAX.
(function () {
  if (window.__snCardTouch) return;
  window.__snCardTouch = true;

  var isTouch = ('ontouchstart' in window) ||
    (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
  if (!isTouch) return;
  document.documentElement.classList.add('sn-touch');

  var MEDIA = '.media.media--hover-effect';
  var active = null;

  // Precargar la segunda foto de las tarjetas cercanas, para que el cambio sea instantáneo.
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var second = en.target.querySelector('img + img');
      if (second && second.getAttribute('loading') === 'lazy') second.setAttribute('loading', 'eager');
      io.unobserve(en.target);
    });
  }, { rootMargin: '400px 0px' }) : null;

  function watch(root) {
    if (!io) return;
    (root || document).querySelectorAll(MEDIA).forEach(function (m) {
      if (m.__snWatched || !m.querySelector('img + img')) return;
      m.__snWatched = true;
      io.observe(m);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; watch(); }, 300);
    })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('touchstart', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('.card-wrapper') : null;
    var m = wrap ? wrap.querySelector(MEDIA) : null;
    if (m && !m.querySelector('img + img')) m = null;
    if (m === active) return;
    if (active) active.classList.remove('sn-show2');
    active = m;
    if (m) {
      var second = m.querySelector('img + img');
      if (second.getAttribute('loading') === 'lazy') second.setAttribute('loading', 'eager');
      m.classList.add('sn-show2');
    }
  }, { passive: true });
})();

// Sinestesia — Diagnóstico de ancho de página (28 sep 2026)
// Solo aparece si se abre la tienda con ?sn_debug=1 (queda activo en esa
// pestaña hasta cerrarla; ?sn_debug=0 lo apaga). Muestra arriba a la izquierda
// el ancho real de la página contra el de la pantalla: si dice "OK" no hay nada
// que se salga por el costado; si no, lista los elementos que llegan más lejos.
// Los clientes nunca lo ven.
(function () {
  try {
    var q = location.search;
    if (/[?&]sn_debug=1/.test(q)) sessionStorage.setItem('sn_debug', '1');
    if (/[?&]sn_debug=0/.test(q)) sessionStorage.removeItem('sn_debug');
    if (sessionStorage.getItem('sn_debug') !== '1') return;
  } catch (e) { return; }

  var caja = document.createElement('pre');
  caja.style.cssText = 'position:fixed;top:4px;left:4px;z-index:2147483647;margin:0;padding:6px 8px;max-width:92vw;color:#fff;font:11px/1.35 Menlo,monospace;white-space:pre-wrap;pointer-events:none;';

  function nombre(el) {
    var c = (typeof el.className === 'string') ? el.className.trim().split(/\s+/).slice(0, 2).join('.') : '';
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + (c ? '.' + c : '');
  }
  function medir() {
    var de = document.documentElement;
    var anchoPag = Math.max(de.scrollWidth, document.body.scrollWidth);
    var altoPag = Math.max(de.scrollHeight, document.body.scrollHeight);
    var anchoPant = de.clientWidth;
    var ok = anchoPag <= anchoPant + 1;
    var lineas = ['PÁGINA ' + anchoPag + ' × ' + altoPag, 'PANTALLA ' + anchoPant + ' — ' + (ok ? 'OK' : 'SE SALE')];
    if (!ok) {
      var lejos = [];
      document.querySelectorAll('body *').forEach(function (el) {
        if (el === caja) return;
        var r = el.getBoundingClientRect();
        if (r.width && r.right > anchoPant + 1) lejos.push([Math.round(r.right + window.scrollX), nombre(el)]);
      });
      lejos.sort(function (a, b) { return b[0] - a[0]; });
      lejos.slice(0, 6).forEach(function (l) { lineas.push(l[0] + '  ' + l[1]); });
    }
    caja.textContent = lineas.join('\n');
    caja.style.background = ok ? 'rgba(0,120,0,0.85)' : 'rgba(170,0,0,0.9)';
  }
  function poner() { document.body.appendChild(caja); medir(); setInterval(medir, 1000); }
  if (document.body) poner(); else document.addEventListener('DOMContentLoaded', poner);
})();
